/* eslint-disable @typescript-eslint/no-explicit-any */
import { message, Modal } from 'antd';
import React, { useEffect } from 'react';
import fa from 'locales/fa.json';
import { useForm } from 'react-hook-form';
import FormInput from 'components/Common/FormInput';
import { faNumber } from 'utils/common.util';
import AntButton from 'components/Common/AntButton';
import FormRadio from 'components/Common/FormRadio';
import request from 'services/request';
import { CreateQuestionUrl, EditQuestionUrl } from 'services/routes';

const CreateQuestionModal: React.FC<{
  isOpen: boolean;
  setOpen: (status) => void;
  updateList?: (options, answer, question, hint) => void;
  id: string;
  defaultValues?: {
    question: string;
    answer: number;
    hint?: string;
    option1: string;
    option2: string;
    option3: string;
    option4: string;
  };
}> = ({ isOpen, setOpen, id, defaultValues, updateList }) => {
  const { handleSubmit, formState, control, reset, setValue } = useForm();
  const onSubmit = async (data): Promise<void> => {
    const { answer, hint, question } = data;
    const options = [
      { id: 1, option: data.option1 },
      { id: 2, option: data.option2 },
      { id: 3, option: data.option3 },
      { id: 4, option: data.option4 },
    ];
    const body = { answer, hint, question, options };
    const res: any = await request.post(
      !defaultValues ? CreateQuestionUrl(id) : EditQuestionUrl(id),
      body,
    );
    if (res.ok) {
      message.success(res.data.message);
      !defaultValues ? reset() : updateList(options, answer, question, hint);
    }
  };

  useEffect(() => {
    if (defaultValues) {
      setValue('question', defaultValues.question);
      setValue('answer', defaultValues.answer);
      setValue('hint', defaultValues.hint);
      setValue('option1', defaultValues.option1);
      setValue('option2', defaultValues.option2);
      setValue('option3', defaultValues.option3);
      setValue('option4', defaultValues.option4);
    }
  }, [defaultValues]);

  return (
    <Modal
      width={800}
      visible={isOpen}
      footer={null}
      onCancel={(): void => setOpen(0)}
      destroyOnClose
    >
      <div className="flex flex-col">
        <h1 className="font-bold text-[18px] self-center">{fa.course.createQuestion}</h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormInput
            control={control}
            name="question"
            rtl
            className="mt-[24px] mb-[52px] toRight"
            rules={{ required: true }}
            title={fa.global.title}
          />
          <FormInput
            control={control}
            name="option1"
            rtl
            className="mb-[28px]"
            rules={{ required: true }}
            title={faNumber(fa.course.option1)}
          />
          <FormInput
            control={control}
            name="option2"
            rtl
            className="mb-[28px]"
            rules={{ required: true }}
            title={faNumber(fa.course.option2)}
          />
          <FormInput
            control={control}
            name="option3"
            rtl
            className="mb-[28px]"
            rules={{ required: true }}
            title={faNumber(fa.course.option3)}
          />
          <FormInput
            control={control}
            name="option4"
            rtl
            className="mb-[28px]"
            rules={{ required: true }}
            title={faNumber(fa.course.option4)}
          />
          <FormInput
            control={control}
            name="hint"
            rtl
            className="mb-[28px]"
            title={faNumber(fa.global.hint)}
          />

          <div className="flex">
            <div className="ml-4">{fa.course.correctAnswer}: </div>
            <FormRadio
              name="answer"
              control={control}
              className="mb-[28px]"
              rules={{ required: true }}
              options={[
                { value: 1, title: faNumber(fa.course.option1) },
                { value: 2, title: faNumber(fa.course.option2) },
                { value: 3, title: faNumber(fa.course.option3) },
                { value: 4, title: faNumber(fa.course.option4) },
              ]}
            />
          </div>

          <div className="width-full center">
            <AntButton
              htmlType="submit"
              className="w-[300px] mb-8 s"
              loading={formState.isSubmitting}
            >
              {fa.global.send}
            </AntButton>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default CreateQuestionModal;
